import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { User, Logueo } from '../models/user';
import { ParameterConst } from 'src/app/util/constant';
import { environment } from 'src/environments/environment'; 
import { AlertaService } from 'src/app/util/alerta.service';
import { MsjDialogService } from 'src/app/service/msjDialogService';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  hide = true;
  userForm: FormGroup;




  constructor(private route: ActivatedRoute,
    private alertaService: AlertaService,private router: Router,
    private msjSnackBar : MsjDialogService) {
     
   }

  ngOnInit(): void {

   /* let user = JSON.parse(localStorage.getItem(ParameterConst.USER_LOGIN));
    console.log("user");
    this.usuarioInicia = user.user;*/

  }



  hasError(controlName: string) {
    return this.userForm.controls[controlName].invalid;
  }


}
